// Input field names, affects service call on backend
// implements NonComplianceCaseRequest interface fields
export enum LostUnitsField {
  ID = "id",
  DSKU = "dsku",
  WAREHOUSE = "warehouseId",
  SHIPPINGPLAN = "shippingPlanId",
  FC_ASN = "fcAsnId",
  CROSSDOCK_ASN = "crossdockAsnId",
  LOST_QUANTITY = "lostQty",
  FOUND_QUANTITY = "foundQty",
  REIMBURSED_AMOUNT = "reimbursedAmount",
  REASON = "reason",
  DISTRIBUTION = "distributionType",
  NOTES = "notes",
  SELLER = "sellerid",
  REPORTER = "reportedBy",
  ASANA = "asanaTicket",
  ZENDESK = "zendeskTicket",
  LOST_DATE = "lostAt",
}

export enum LostUnitsValidationErrorMessages {
  ASN_FORMAT = "ASN must have 5 to 7 numbers",
  ASN_INVALID = "ASN doesn't exist", // used to re-map error message from commons-clients
  SHIPMENT_FORMAT = "Shipment must have 5 to 7 numbers",
  UNKNOWN = "Unknown error submitting case, please try again later.",
  DSKU_REQUIRED = "DSKU is required",
  DSKU_FORMAT = "Invalid DSKU must start with a D and be 11 characters",
  QTY_REQUIRED = "Quantity is required",
  QTY_POSITIVE = "Quantity must be positive",
  WAREHOUSE_INVALID = "Invalid Warehouse identifier",
  ZENDESK_FORMAT = "Invalid Zendesk ticket",
  ASANA_FORMAT = "Invalid Asana URL",
  REPORTER_FORMAT = "Reporter needs to be a single word",
  SELLER_FORMAT = "Invalid Seller, needs to be a single word",
  LOSTAT_REQUIRED = "Lost on date is required",
  INVALID_DATE_FORMAT = "Invalid date format must be Year-Month-Day i.e. 2021-01-25",
  REIMBURSED_FORMAT = "Invalid dollar amount must be of format 123.32 or 123",
}
